import { DateTimeUtils, lt, useDateTimeLocalizationInfo } from '@mews/framework';
import { TableHeader, Typography } from '@optimus-web/core';
import { useCityLedgerSelectedDate } from '../../context/CityLedgerFilterContext';
import { ExportMenu } from '../ExportDialog/ExportMenu';
import { Filters } from '../Filters';

export const CityLedgerHeader = () => {
    const { selectedDate } = useCityLedgerSelectedDate();

    const localizationInfo = useDateTimeLocalizationInfo();
    const dateString = selectedDate && DateTimeUtils.dateIsoStringToDateString(selectedDate, localizationInfo);

    return (
        <TableHeader
            title={lt('LedgersTableHeaderTitle')}
            subTitle={
                dateString ? (
                    <Typography
                        data-test-id="city-ledger-table-subtitle"
                        textStyle="titleSmall"
                        variant="tertiary"
                        as="span"
                    >
                        {dateString}
                    </Typography>
                ) : null
            }
            rightSide={
                <>
                    <Filters />
                    <ExportMenu />
                </>
            }
        />
    );
};
